var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentContacts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-content-contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-content-contacts",
    stroke: "#53575C",
    transform: "translate(1.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0.5 C21.6903559,0.5 22.3153559,0.779822031 22.767767,1.23223305 C23.220178,1.68464406 23.5,2.30964406 23.5,3 L23.5,3 L23.5,13 C23.5,13.6903559 23.220178,14.3153559 22.767767,14.767767 C22.3153559,15.220178 21.6903559,15.5 21,15.5 L21,15.5 L3,15.5 C2.30964406,15.5 1.68464406,15.220178 1.23223305,14.767767 C0.779822031,14.3153559 0.5,13.6903559 0.5,13 L0.5,13 L0.5,3 C0.5,2.30964406 0.779822031,1.68464406 1.23223305,1.23223305 C1.68464406,0.779822031 2.30964406,0.5 3,0.5 L3,0.5 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1923882,2.65095548 L14.1213203,9.72202329 C12.9497475,10.8935962 11.0502525,10.8935962 9.87867966,9.72202329 L2.80761184,2.65095548",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentContacts);
export default __webpack_public_path__ + "static/media/ic-content-contacts.408e002a1a693cd6082b7f41e92c1fdf.svg";
export { ForwardRef as ReactComponent };